import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import Heading from '@polestar/component-warehouse-react/components/heading/Heading';
import Paragraph from '@polestar/component-warehouse-react/components/paragraph/Paragraph';
import Spacer from '@polestar/component-warehouse-react/components/spacer/Spacer';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { AnchorButton, Button, PrimaryAnchorButton, PrimaryButton, TextAnchorButton, TextButton, SecondaryAnchorButton, SecondaryButton, } from '@polestar/component-warehouse-react/components/button/Button';
const EmptyState = forwardRef(({ title, description, action, secondaryAction, category, ...props }, ref) => {
    if (action.type !== Button &&
        action.type !== AnchorButton &&
        action.type !== PrimaryButton &&
        action.type !== PrimaryAnchorButton &&
        action.type !== SecondaryButton &&
        action.type !== SecondaryAnchorButton) {
        // eslint-disable-next-line no-console
        console.error(`EmptyState: please use the provided components and do not use something else than a Button/AnchorButton for the "action" property! (see "${title}" component)`);
        return null;
    }
    if (secondaryAction &&
        (secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.type) !== SecondaryButton &&
        (secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.type) !== SecondaryAnchorButton &&
        (secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.type) !== TextButton &&
        (secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.type) !== TextAnchorButton &&
        action.type !== PrimaryButton &&
        action.type !== PrimaryAnchorButton &&
        action.type !== SecondaryButton &&
        action.type !== SecondaryAnchorButton) {
        // eslint-disable-next-line no-console
        console.error(`EmptyState: please use the provided components and do not use something else than a Button/AnchorButton for the "secondaryAction" property! (see "${title}" component)`);
        return null;
    }
    // clone element to ensure that trailing icon & icon color always at least exist
    const actionChild = React.Children.only(action);
    const secondaryActionChild = secondaryAction ? React.Children.only(secondaryAction) : undefined;
    return (React.createElement(Container, { ...props, ref: ref },
        category && (React.createElement(Heading, { as: "span", accent: true }, category)),
        React.createElement(Heading, null, title),
        React.createElement(Spacer, { spacing: Spacings.medium }),
        React.createElement(Paragraph, null, description),
        React.createElement(Spacer, { spacing: Spacings.medium }),
        actionChild,
        !!secondaryAction && React.createElement(Spacer, { spacing: Spacings.medium }),
        secondaryActionChild));
});
EmptyState.displayName = 'EmptyState';
export default EmptyState;
const Container = styled.div ``;
Container.displayName = `Container`;
